<template>
  <div>
    <v-layout column>
      <v-flex>
        <h4>{{properties.title}}</h4>
      </v-flex>
      <v-layout row>
        <v-tooltip bottom>
          <v-btn
            :disabled="this.properties.disable"
            slot="activator"
            class="v-btn-2"
            color="primary"
            round
            @click="pickFile"
          >
            <v-icon>{{(showDropAudio ? "music_note" : "music_off")}}</v-icon>
          </v-btn>
          <span>{{audioTooltip}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="showDropAudio">
          <v-btn class="v-btn-2" color="secondary" round slot="activator" @click="playAudio">
            <v-icon>play_arrow</v-icon>
          </v-btn>
          <span>{{$translate('PLAY_AUDIO')}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="showDropAudio">
          <v-btn
            :disabled="this.properties.disable"
            class="v-btn-2"
            color="secondary"
            round
            slot="activator"
            @click="clearAudio"
          >
            <v-icon small>delete</v-icon>
          </v-btn>
          <span>{{$translate('DELETE_AUDIO')}}</span>
        </v-tooltip>
      </v-layout>
      <v-flex>
        <h4>{{this.audioName}}</h4>
      </v-flex>
    </v-layout>
    <input
      type="file"
      style="display: none"
      ref="audioInput"
      accept="audio/*"
      @change="onAudioFilePicked"
    >
  </div>
</template>

<script>
import appConfig from "../../../config/app_config";

export default {
  name: "EventAudioLoader",
  props: {
    properties: Object
  },
  watch: {
    properties: {
      handler(data) {
        if (data.audioUrl !== undefined && data.audioUrl !== "") {
          this.audioName = this.properties.audioName;
          this.audioUrl = this.properties.audioUrl;
          this.showDropAudio = true;
        } else {
          this.showDropAudio = false;
          this.audioName = "";
          this.audioUrl = "";
        }
      },
      deep: true
    }
  },
  created() {
    if (
      this.properties.audioUrl !== undefined &&
      this.properties.audioUrl !== ""
    ) {
      this.audioName = this.properties.audioName;
      this.audioUrl = this.properties.audioUrl;
      this.showDropAudio = true;
    }
  },
  data() {
    return {
      showDropAudio: false,
      audioTooltip: "upload an audio file",
      audioName: ""
    };
  },
  methods: {
    playAudio() {
      let audio = new Audio(this.audioUrl);
      audio.addEventListener;
      audio
        .play()
        .then(r => console.log("response", r), e => console.warn("error", e));
    },
    pickFile() {
      this.$refs.audioInput.click();
    },
    clearAudio() {
      this.audioUrl = "";
      this.audioName = "";
      this.showDropAudio = false;
      this.$emit(this.properties.signalName, {
        signalName: this.properties.signalName,
        file: "",
        url: ""
      });
    },
    onAudioFilePicked(a) {
      const maxSize = appConfig.maxSize.arrivalAudioSize;
      const files = a.target.files;
      if (files[0] !== undefined) {
        if (files[0].size > maxSize) {
          window.EventBus.fire(
            "activateSnackBar",
            "File can't be bigger than 1MB"
          );
          return;
        }
        this.audioName = files[0].name;
        if (this.audioName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.audioUrl = fr.result;
          this.audioFile = files[0];
          this.showDropAudio = true;
          this.$emit(this.properties.signalName, {
            signalName: this.properties.signalName,
            file: this.audioFile,
            url: this.audioUrl
          });
        });
      } else {
        window.EventBus.fire("activateSnackBar", "File is not available");
        this.audioUrl = "";
        this.audioFile = "";
        this.audioName = "";
        this.showDropAudio = false;
        this.$emit(this.properties.signalName, {
          signalName: this.properties.signalName,
          file: "",
          url: ""
        });
      }
    }
  }
};
</script>

<style>
.v-btn-2 {
  min-width: 1em;
}

.musicIcon {
  margin-top: 1.5em !important;
  margin-left: -14em !important;
}

.playIcon {
  margin-top: 1.5em !important;
}

.trashIcon {
  margin-top: 1.5em !important;
}
</style>
